
import { HttpStatus } from '@core/classes/http-status.class';

import * as fromRulesModel from '@app/models/rules';
import * as fromRulesState from './rules.state';
import * as fromRulesActions from './rules.actions';

export function settingsRulesReducer(state = fromRulesState.initialState, action: fromRulesActions.SettingsRulesActions): fromRulesState.SettingsRules {

	const CONDITION_LABELS_SEARCHABLE_KEYS_EMPTY_DEFAULT = ['request_labels','version_labels'];
	const ACTION_SORTABLE_KEYS = ['access_version_status','access_version_status_update'];

    switch (action.type) {
		// LOAD: EVENTS PERSISTED RULES FOR THE LIST
		case fromRulesActions.SettingsRulesActionType.LoadRulesSuccess:

			return {...state, rules: action.rules};
		
		// LOAD: load persisted rule by id selected on the rules list
		case fromRulesActions.SettingsRulesActionType.LoadRuleSuccess:
			// get the current event
			const currRuleEventIdx = state.availables.events.findIndex((a: fromRulesModel.AvailableRuleEventElement) => a.key == action.rule.key);
			if(currRuleEventIdx == -1)
				return state;
			// parallel to the current, we have to create all the forms for each conditon / action of the loaded rule, 
			// condition forms
			const currRuleForms = [];
			const rconds = action.rule.conditions.map((rc) => {
				const fffc = new fromRulesModel.AvailableRuleItemForm(state.availables.events[currRuleEventIdx],
																			fromRulesModel.AvailableRuleItemFormTypes.condition, rc.variable )
				let nrc = {...rc, form_id: fffc.id}; // associate new form with the condition in editor
				currRuleForms.push(fffc);
				return nrc;
			})

			const racts = action.rule.actions.map((ra) => {
				const fffa = new fromRulesModel.AvailableRuleItemForm(state.availables.events[currRuleEventIdx],
																			fromRulesModel.AvailableRuleItemFormTypes.action, ra.key )
				let nra = {...ra, form_id: fffa.id}; // associate new form with the condition in editor
				currRuleForms.push(fffa);
				return nra;
			})

			// TODO oct-2023: do same with actions to add them to the current rule

			// set current rule completed (pending to add actions loaded as well )
			const current = {...action.rule, conditions: rconds, actions: racts}
			return {
				...state, 
				edit: {...state.edit, 
					current: current, 
					forms: [...currRuleForms]
				}
			};

		// LOAD: ALL Events first load sucesss
		case fromRulesActions.SettingsRulesActionType.LoadAvailableEventsSuccess:

			return {...state, 
				availables: {...state.availables, events: action.events, conditions: [], actions: [] }
			};
		// ACTION: Here we set the main key of the event selected by user
		case fromRulesActions.SettingsRulesActionType.SetRuleEvent:
			const newEventIdx = state.availables.events.findIndex((a: fromRulesModel.AvailableRuleEventElement) => a.key == action.eventKey);
			if(newEventIdx == -1)
				return state;
			return {
				...state, 
				edit: {
					...state.edit, 
					current: { // carefully, we dont want to overwrite the current rule on edit.
						...state.edit.current, key: action.eventKey
					},
					event: {
						key: state.availables.events[newEventIdx].key,
						conditions: state.availables.events[newEventIdx].conditions.map((c) => c.key),
						actions: state.availables.events[newEventIdx].actions.map((a) => a.key)
					}
						
				}
			};

		// ACTION: when user change event we restart everything
		case fromRulesActions.SettingsRulesActionType.UpdateRuleEvent:
			const updatedEventIdx = state.availables.events.findIndex((a: fromRulesModel.AvailableRuleEventElement) => a.key == action.eventKey);
			if(updatedEventIdx == -1)
				return state;
			
			return {
				...state, 
				edit: {
					...fromRulesState.initialState.edit,
					current: { // carefully, we dont want to overwrite the current rule on edit.
						...fromRulesState.initialState.edit.current, 
						key: action.eventKey,
						name: state.edit.current.name
					},
					forms: fromRulesState.initialState.edit.forms,
					event: {
						key: state.availables.events[updatedEventIdx].key,
						conditions: state.availables.events[updatedEventIdx].conditions.map((c) => c.key),
						actions: state.availables.events[updatedEventIdx].actions.map((a) => a.key)
					}
						
				}
			};
		
		// LOAD: conditions of the event selected
		case fromRulesActions.SettingsRulesActionType.LoadAvailableConditionsSuccess:
			const newConds = !Array.isArray(action.conditions) ? [action.conditions] : action.conditions;

			return {
				...state, 
				availables: { ...state.availables, 
					conditions: [...state.availables.conditions, ...newConds]
				}
			};
		
		// LOAD: actions of the event selected
		case fromRulesActions.SettingsRulesActionType.LoadAvailableActionsSuccess:
			
			if(!Array.isArray(action.actions)){
				console.error("  RULES REDUCER actions variables are not an array for "+action.actionItem.key, action.actions)
			}
			const actVars = !Array.isArray(action.actions) ? [action.actions] : action.actions;

			// Sort values by description for specified keys
			/**
			 * IMPORTANT: we sort the action variables by description for some keys
			 * This is to ensure that the actions are displayed in a consistent order. So,
			 * action.actions is an array of objects, each with a key, description, values, and options, 
			 * and here we sort the values array only for those objects within action.actions 
			 * where the key matches one of the keys in ACTION_SORTABLE_KEYS.
			 */
			let sortedVars = [...actVars].map(item => {
				if (ACTION_SORTABLE_KEYS.includes(item.key)) {
					return {
						...item,
						values: item.values && Array.isArray(item.values)
							? [...item.values].sort((a, b) => a.description.localeCompare(b.description))
							: item.values
					};
				}
				return item;
			});
			// we need to extend the object because dooont match the action interface
			// Extend the action item with sorted variables
			const newAction = {...action.actionItem, variables: sortedVars}

			return {
				...state, 
				availables: { ...state.availables, 
					actions: [...state.availables.actions, newAction]
				}
			};
		
		// ACTION: add new conditon to current rule and new form
		case fromRulesActions.SettingsRulesActionType.AddRuleCondition:
			// get the current available event
			const currEventIdx = state.availables.events.findIndex((a: fromRulesModel.AvailableRuleEventElement) => a.key == state.edit.current.key);
			if(currEventIdx != -1 && state.availables.events[currEventIdx].conditions.length==0 && state.availables.conditions?.length == 0)
				return state;

			// let condddddds =state.availables.events[currEventIdx].conditions;
			// get the first current available event conditions
			const aconditionitem: fromRulesModel.AvailableRuleItem  = state.availables.events[currEventIdx].conditions[0];

			const acondition: fromRulesModel.AvailableRuleEventCondition = state.availables.conditions.filter(
							(ca: fromRulesModel.AvailableRuleEventCondition  ) => ca.key == aconditionitem.key)[0];
			
			/**  Create a new edit condition form for this new condition */
			const currForms = [...state.edit.forms];
			const newConditonForm = new fromRulesModel.AvailableRuleItemForm(state.availables.events[currEventIdx],fromRulesModel.AvailableRuleItemFormTypes.condition );
			currForms.push(newConditonForm);

			/**  Create new condition to current rule, we manage parallel to the previous form_id, not by position anymore */
			// there no be called (and displayed in front) until all conditions are loaded, if some fails.
			if (acondition.values?.length == 0 || acondition.options?.length == 0){
				console.error(" RULES REDUCER CONDITION EMPTY for key "+acondition.key, acondition)
			}
			const pcondition: fromRulesModel.RuleCondition = {
				form_id: newConditonForm.id,
				variable: acondition.key,
				condition: acondition.options?.length > 0 ? acondition.options[0].key : '',
				value: acondition.values?.length > 0 ? acondition.values[0].key.toString() : ''
			}
			//  put new condition into the ones already in the current rule
			const currConditions = [...state.edit.current.conditions];
			currConditions.push(pcondition);
			
			return {...state, edit: {...state.edit, 
					current : {...state.edit.current, conditions: currConditions },
					forms: currForms }
				};
		
		// UPDATE: Change one conditon on current rule and the associated form by the condition form_id
		case fromRulesActions.SettingsRulesActionType.ChangeRuleConditionValues:
			const currrEvent = state.availables.events.filter((a: fromRulesModel.AvailableRuleEventElement) => a.key == state.edit.current.key);

			if(currrEvent?.length && currrEvent[0].conditions.length==0 && state.availables.conditions?.length == 0)
				return state;
		
			const aavailableCondition: Array<fromRulesModel.AvailableRuleEventCondition> = state.availables.conditions.filter(
								(ca: fromRulesModel.AvailableRuleEventCondition  ) => ca.key == action.condition.variable);
			/**  Edit current rule conditions */
			const myRuleConds = [...state.edit.current.conditions];
			const currentRuleCIdx = myRuleConds.findIndex(
							(ca: fromRulesModel.RuleCondition  ) => ca.form_id == action.condition.form_id);
			
			if(currentRuleCIdx == -1  || aavailableCondition?.length == 0)
				return state;
			// create new condition with new form values
			let ppcondition = {
				form_id: myRuleConds[currentRuleCIdx].form_id,
				variable: action.condition.variable,
				condition: action.condition.condition,
				value: action.condition.value
			}
			// when change of variable in form create new rule condition with default values
			if (aavailableCondition[0].values?.length == 0 || aavailableCondition[0].options?.length == 0){
				console.error(" RULES REDUCER CONDITION EMPTY for key "+action.condition.variable, aavailableCondition)
			}
			if( myRuleConds[currentRuleCIdx].variable != action.condition.variable){
				// check first value is selectable or not and put second
				let newCondValue = aavailableCondition[0].values?.length > 0 ? aavailableCondition[0].values[0].key.toString() : '';
				const firstValue: fromRulesModel.AvailableRuleConditionValueItem =  aavailableCondition[0].values?.length > 0 ? aavailableCondition[0].values[0] : null;
					if(firstValue.hasOwnProperty('options') 
							&& firstValue?.options.hasOwnProperty('selectable') 
							&& !firstValue?.options.selectable && aavailableCondition[0].values?.length > 1)
					{
						newCondValue = aavailableCondition[0].values[1].key.toString();
					} 
				ppcondition = {
					form_id: myRuleConds[currentRuleCIdx].form_id,
					variable: action.condition.variable,
					condition: aavailableCondition[0].options?.length > 0 ? aavailableCondition[0].options[0].key : '',
					value: newCondValue
				}

				// IMPORTANT, for empty initial value on conditions for tags.
				if( CONDITION_LABELS_SEARCHABLE_KEYS_EMPTY_DEFAULT.includes(ppcondition.variable))
					ppcondition.value = '';
			}
			myRuleConds[currentRuleCIdx] = ppcondition;
			
			/**  Edit form by id: Find the index of the object to replace within the array */
			const myCondFormIdx = state.edit.forms.findIndex((cf) => cf.id == action.condition.form_id)

			// Create a new array of forms
			const currrForms  = [...state.edit.forms];
			// Check if the object exists in the array
			if (myCondFormIdx !== -1) {
				// if exists the object replaced with new form values else as it is...
				currrForms[myCondFormIdx] =  {...currrForms[myCondFormIdx], key: action.condition.variable, description: aavailableCondition[0].description};
	
			}
			return {...state, 
				edit: {...state.edit, 
					current : {...state.edit.current, conditions: myRuleConds },
					forms: currrForms }
			};
		
		// ACTION: we remove one edit current rule condition and its form by local form_id
		case fromRulesActions.SettingsRulesActionType.RemoveRuleCondition:
			return {
				...state,
				edit: {
					...state.edit,
					current: {...state.edit.current, 
						conditions: state.edit.current.conditions.filter((ecc: fromRulesModel.RuleCondition) => ecc.form_id !== action.formId)
					},
					forms: state.edit.forms.filter((ef: fromRulesModel.AvailableRuleItemFormModel) => ef.id !== action.formId)
				}
			}
		// SEARCH: search o rules aconditions, set term in the form.
		case fromRulesActions.SettingsRulesActionType.SetRuleConditionsFormTerm:

			// filter search results found
			const myAvailableRuleCondition: fromRulesModel.AvailableRuleEventCondition = state.availables.conditions.filter(
				(ca: fromRulesModel.AvailableRuleEventCondition  ) => ca.key == action.form.key )[0];
		
			// MAYBE MAKE case fromRulesActions.sensitive 
			let foundValues = [];
			if (action.term != ''){ // avoid not selecteble on filters => return non selectable always for headers
				foundValues = myAvailableRuleCondition.values.filter((arcv: fromRulesModel.AvailableRuleConditionValueItem) => arcv.description.toLowerCase().includes(action.term.toLowerCase()) || !arcv.options.selectable );
			}

			// Check no selectable values
			const selectableCondVal = foundValues.find((arcv: fromRulesModel.AvailableRuleConditionValueItem) => arcv.options.selectable)
			if(!selectableCondVal){
				foundValues = [];
			}
			// remove header for empty groups in results.
			const cleanedCValues = foundValues.filter((arcvf, $index, $list) => {
				if (!arcvf.options.selectable) {
				  // If the current item is not selectable, include it only if it's not the last
				  // and the following item is selectable.
				  return ($index < $list.length - 1 && $list[$index + 1].options.selectable) 
				}
				return true;
			});
			  
			// set form updated in store 
			return {
				...state,
				edit: {
					...state.edit,
					forms: state.edit.forms.map(obj => 
						obj.id === action.form.id ? { ...obj, search: {...obj.search, term:action.term, found: cleanedCValues} } : obj
					  )
				}
			}

		// SEARCH: search on rules actions, set term in the form.
		case fromRulesActions.SettingsRulesActionType.SetRuleActionsFormTerm:

			// filter search results found
			const myAvailableRuleAction: fromRulesModel.AvailableRuleEventAction = state.availables.actions.filter(
				(aa: fromRulesModel.AvailableRuleEventAction  ) => aa.key == action.form.key )[0];
			// MAYBE MAKE case fromRulesActions.sensitive
			let foundActionValues = [];
			if (action?.term != '' && action?.key != ''){
				const actionVariable = myAvailableRuleAction.variables.filter((arav) => arav.key == action.key)[0];
				foundActionValues = actionVariable.values.filter((arav) => arav.description.toLowerCase().includes(action.term.toLowerCase()) || !arav.options.selectable);
			}
			// Check no selectable values
			const selectableActVal = foundActionValues.find((arav: fromRulesModel.AvailableRuleActionVariableValueItem) => arav.options.selectable)
			if(!selectableActVal){
				foundActionValues = [];
			}
			// remove header for empty groups in results.
			const cleanedAValues = foundActionValues.filter((aravf, $index, $list) => {
				if (!aravf.options.selectable) {
				  // If the current item is not selectable, include it only if it's not the last
				  // and the following item is selectable.
				  return ($index < $list.length - 1 && $list[$index + 1].options.selectable) 
				}
				return true;
			});
			// set form updated in store 
			return {
				...state,
				edit: {
					...state.edit,
					forms: state.edit.forms.map(obj => 
						obj.id === action.form.id ? { ...obj, search: {...obj.search, term:action.term, found: cleanedAValues} } : obj
					  )
				}
			}
		// clean edit state
		case fromRulesActions.SettingsRulesActionType.ClearRule:
			return {
				...state, 
				edit: fromRulesState.initialState.edit
			};

		case fromRulesActions.SettingsRulesActionType.AddRuleAction:
			// get the current available event
			const currAEventIdx = state.availables.events.findIndex((a: fromRulesModel.AvailableRuleEventElement) => a.key == state.edit.current.key);
			if(currAEventIdx == -1 || state.availables.events[currAEventIdx].actions.length==0 && state.availables.actions?.length == 0)
				return state;
			// get the first current available event actions
			const aActionItem: fromRulesModel.AvailableRuleItem  = state.availables.events[currAEventIdx].actions[0];
			if (!aActionItem)
				return state; // deprecated rules
			const aActionIdx = state.availables.actions.findIndex(
							(ca: fromRulesModel.AvailableRuleEventAction  ) => ca.key == aActionItem.key);
			if(aActionIdx == -1 )
				return state;
			/**  Create a new edit action form for this new action */
			const currAForms = [...state.edit.forms];
			const newActionForm = new fromRulesModel.AvailableRuleItemForm(state.availables.events[currAEventIdx],fromRulesModel.AvailableRuleItemFormTypes.action );
			currAForms.push(newActionForm);
			
			/**  Create new action to current rule, we manage parallel to the previous form_id, not by position anymore */
// TODO: there are still pendin actions to load  properly
			if (state.availables.actions[aActionIdx].variables?.length == 0 ){
				console.error(" RULES REDUCER ACTION EMPTY for key "+state.availables.actions[aActionIdx].key, state.availables.actions[aActionIdx])
				return state;
			}
			let actionParams = {};
			// when multiple is true, we do not set first value in parameters
			Object.keys(state.availables.actions[aActionIdx].variables).forEach((key) => {
				const avariable = state.availables.actions[aActionIdx].variables[key];
				if( !avariable.options.multiple && avariable.values?.length > 0){
					actionParams[avariable.key] = avariable.values[0].key.toString();
					const firstVal = avariable.values[0];
					if(firstVal.hasOwnProperty('options') 
							&& firstVal.options.hasOwnProperty('selectable') 
							&& !firstVal.options.selectable && avariable.values.length > 1)
					{
						actionParams[avariable.key] = '';
					}
				}
				else 
					actionParams[avariable.key] = [];
		});

			const paction: fromRulesModel.RuleAction = {
				id: 0,
				form_id: newActionForm.id,
				key: state.availables.actions[aActionIdx].key,
				parameters: actionParams
			}
			//  put new action into the ones already in the current rule
			const currActions = [...state.edit.current.actions];
			currActions.push(paction);
			
			return {...state, edit: {...state.edit, 
					current : {...state.edit.current, actions: currActions },
					forms: currAForms }
				};
		
		case fromRulesActions.SettingsRulesActionType.RemoveRuleAction:

			return {
				...state,
				edit: {
					...state.edit,
					current: {...state.edit.current, 
						actions: state.edit.current.actions.filter((eca: fromRulesModel.RuleAction) => eca.form_id !== action.formId)
					},
					forms: state.edit.forms.filter((ef: fromRulesModel.AvailableRuleItemFormModel) => ef.id !== action.formId)
				}
			}

		case fromRulesActions.SettingsRulesActionType.ChangeRuleActionKey:
			// key could be repeated in several actions, form_id not. so all actions should have it.
			// get the new event action from availables to update by the new key given in the new action
			const akActionIdx = state.availables.actions.findIndex(
							(ca: fromRulesModel.AvailableRuleEventAction  ) => ca.key == action.action.key);
			if(akActionIdx == -1 )
				return state;
			const nextActionAvailable = state.availables.actions[akActionIdx];

			// update the current rule action and parameters with the new ones on the availables
			// update of the params
			let nextActionParameters = {};
			nextActionAvailable.variables.forEach((vvv: fromRulesModel.AvailableRuleActionVariable) => {
				// new params when multiple or not
				nextActionParameters[vvv.key] = vvv?.options.multiple ? [] : vvv.values[0].key.toString();
				// when first item is not selectable we set not value
				if ( vvv.values[0].hasOwnProperty('options') &&  vvv.values[0].options != null && !vvv.values[0].options.selectable){
					nextActionParameters[vvv.key] = vvv?.options.multiple ? [] : '';
				}
			});
			// new action after changed key with new parameters from availables and default values.
			let actionUpdated : fromRulesModel.RuleAction = {
				id: action.action.id,
				form_id: action.action.form_id,
				key: action.action.key,
				parameters: nextActionParameters
			}
			// set new action in current rule actions at same index found by its form_id
			// form_id is unique, key could be repeated.
			const currEditActions = [...state.edit.current.actions];
			const currEditActionIdx = state.edit.current.actions.findIndex((ca) => ca.form_id == action.action.form_id ) 
			if( currEditActionIdx == -1)
				return state;

			currEditActions[currEditActionIdx] = actionUpdated;


			/**  UPDATE the edit action form for the current action by its form id */
			const myActKFormIdx = state.edit.forms.findIndex((cf) => cf.id == action.action.form_id)

			// Create a new array of forms
			const currKForms  = [...state.edit.forms];
			// Check if the object exists in the array
			if (myActKFormIdx !== -1) {
				// if exists the object replaced with new form values else as it is...
				currKForms[myActKFormIdx] =  {...currKForms[myActKFormIdx], key: action.action.key, description: nextActionAvailable.description};
	
			}
			// update the current action in the edit current (the current rule)
			return {...state, 
				edit: {...state.edit, 
						current:  {...state.edit.current, 
							actions: currEditActions
						},	
						forms: currKForms}
				};

			case fromRulesActions.SettingsRulesActionType.ChangeRuleAction:
				// set the new action to update current rule action and form matching its form_id 
				// (not by its key, because key could be repeated)
				const ActionToUpIdx = state.edit.current.actions.findIndex(
						(ca: fromRulesModel.RuleAction  ) => ca.form_id == action.action.form_id);
				if(ActionToUpIdx == -1 )
					return state;
			
				const actionToUpdate = state.edit.current.actions[ActionToUpIdx];
	
				let cActions = [...state.edit.current.actions]; // copy of the current actions to be able to manipulate them.
				const currActionToUpIdx = state.edit.current.actions.findIndex((ca) => ca.form_id == action.action.form_id ) 

				if( currActionToUpIdx == -1)
					return state;

				cActions[currActionToUpIdx] = action.action;
	
				// return updated state;
				return {...state, edit: {...state.edit, 
						current: {...state.edit.current, 
							actions: cActions
						},	
					}};
		
		// EDITOR ACTION: change current rule condition AND / OR control
		case fromRulesActions.SettingsRulesActionType.SetRuleConditionsControl:

			return {
				...state, 
				edit: { ...state.edit, 
					current:  {...state.edit.current, conditions_control: action.control}
				}
			};

		// EDITOR ACTION: change current rule name
		case fromRulesActions.SettingsRulesActionType.SetRuleDescription:

			return {
				...state, 
				edit: { ...state.edit, 
					current:  {...state.edit.current, name: action.description }
					
					}
			};


		

		// RULES LIST ACTIONS
		case fromRulesActions.SettingsRulesActionType.SetActiveRule:

			return {
				...state, 
				rules: state.rules.map(
					(r: fromRulesModel.RuleListItem) => r.id == action.ruleId ? {...r, active: action.active } : r
				)
			};
		
		case fromRulesActions.SettingsRulesActionType.SetActiveRuleError:

			return {
				...state, 
				rules: state.rules.map(
					(r: fromRulesModel.RuleListItem) => r.id == action.ruleId ? {...r, active: !action.active} : r
				)
			};
		case fromRulesActions.SettingsRulesActionType.SaveRuleSuccess:
			// Create a copy of the current rule to keep each form_id associated
			const updatedRuleOld = { ...state.edit.current };


			const updatedRule = { ...state.edit.current, id: action.rule.id, actions: state.edit.current.actions.map((cact, index) => {
							// Use the id from the corresponding object in values
							return { ...cact, id: action.rule.actions[index].id };
						})
			 };

			// Update the conditions arrived in rule response with its proper form_id
			updatedRule.conditions = updatedRule.conditions.map((currentCond) => {
				const newCond = action.rule.conditions.find((c) => c.variable === currentCond.variable && c.value.toString() == currentCond.value.toString());
				return newCond ? {  ...newCond,...currentCond } : currentCond;
			});

			// Update the actions arrived in rule response with its proper form_id
			updatedRule.actions = updatedRule.actions.map((currentAct) => {
				const newAct = action.rule.actions.find((a) => a.key === currentAct.key);
				return newAct ? {  ...newAct, ...currentAct } : currentAct;
			});

			return {
				...state, 
				edit:  {...state.edit, 
					current:  updatedRule }
			};
	/**
		// TODO: pending if this is needed or not.
		case SettingsRulesActionType.SetEditSelectScroll:

			let scroll = state.editing_scroll.filter((e: SettingsRulesEditScroll) => e.key != action.key);
			
			scroll.push({
				key: action.key,
				value: action.scroll
			});

			return {
				...state, 
				editing_scroll: scroll
			};
			
*/

	    default:
	        return state;
    }
}
